import React from 'react';
import {connect} from 'react-redux';
import {Button, Glyphicon} from 'react-bootstrap';
import Truncate from 'react-truncate';
import UserProfileInvited from '../../assets/img/user_profile_invited.svg';
import UserProfileRegistered from '../../assets/img/user_profile_registered.svg';
import UserProfileExpired from '../../assets/img/user_profile_expired.svg';

const Staff = ({
  staff, row, onEditStaffClicked, onResendClicked
}) => {
  let {status} = staff.attributes;

  if (!status) {
    status = '';
  }

  const isEditable = status !== 'disabled';
  const isResendable = status === 'invited' || status === 'expired';
  const isExpired = status === 'expired';
  const isRegistered = status === 'registered';
  const isInvited = status === 'invited';

  return (
    <div className="my-staff-card">
      <div className="my-staff-card-image-container">
        {isRegistered && (
        <img src={UserProfileRegistered} />
          )}
        {isInvited && (
        <img src={UserProfileInvited} />
          )}
        {isExpired && (
        <img src={UserProfileExpired} />
          )}
      </div>
      <div className="staff-item">
        <div className="panel-body">
          {isEditable && (
          <div className="edit-button-area">
            <Button
              className="edit-button"
              type="button"
              onClick={() => onEditStaffClicked(staff.links.update, row, status, staff.id)}
            >
              <Glyphicon
                className="edit-icon"
                glyph="edit"
              />
            </Button>
          </div>
          )}
          <div className="lower-area">
            <div className="info">
              <div className="store-name">
                {staff.attributes['store-name']}
              </div>
              <div className="staff-name">
                <Truncate lines={2}>
                  {staff.attributes.name}
                </Truncate>
              </div>
              <div className="status">
                {`${status.toUpperCase()} ${staff.attributes['status-updated-at']}`}
              </div>
            </div>
            {isResendable && (
            <div className="my-staff-button-container">
              <Button
                className="red-btn"
                onClick={() => onResendClicked(staff.links['resend-invitation'], staff.id)}
              >
                  Resend
              </Button>
            </div>
          )}
          </div>
        </div>

      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  staff_member_row: state.staff.staff_member_row,
  staff_member_id: state.staff.staff_member_id
});

export default connect(mapStateToProps)(Staff);



// WEBPACK FOOTER //
// ./src/components/my-staff/staff.jsx